import React, { FC, ReactNode } from 'react';

import { InfoCircle, UploadedFileIcon } from '../../../../assets/icons/index';
import { AlertDialogWrapper } from '../../../../components/alert-dialog/index';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';
import { VaultSelect } from '../../../../types/vault.types';
import { getFileDisplayName } from '../../../../utils/file-upload-duplicate-names.util';
import { RenameModal } from '../../../vault/modals/rename-modal';

type EventFileUploadRenameModalProps = {
  currentName?: string;
  folderNames: string[];
  isOpen: boolean;
  onClose: () => void;
  onOpenChange: (open: boolean) => void;
  onSuccess: (name: string | undefined) => void;
};

export const EventFileUploadRenameModal: FC<EventFileUploadRenameModalProps> = ({
  currentName,
  folderNames,
  isOpen,
  onClose,
  onOpenChange,
  onSuccess,
}) => (
  <AlertDialogWrapper control={{ onOpenChange, open: isOpen }}>
    <RenameModal
      currentName={currentName}
      folderNames={folderNames}
      onClose={onClose}
      onSuccess={onSuccess}
      type={VaultSelect.FILE}
    />
  </AlertDialogWrapper>
);

type EventFileDuplicateFeedbackProps = {
  doc?: { name?: string };
  docLink?: string;
  isDuplicate: boolean;
  onRename: (fileName: string) => void;
};

export const EventFileDuplicateFeedback: FC<EventFileDuplicateFeedbackProps> = ({
  doc,
  docLink,
  isDuplicate,
  onRename,
}) => {
  if (!docLink || !isDuplicate) return null;

  return (
    <div className="flex items-center gap-2 pl-3">
      <span className="text-xs font-[450] text-fireside-600">
        <AppFormattedMessage id="FILE_EXISTS" />
      </span>
      <Button
        className="w-fit p-0 text-xs font-[450] text-brand-700 underline"
        onClick={() => onRename(getFileDisplayName(doc))}
        styleType="NONE"
        type="button"
      >
        <AppFormattedMessage id="RENAME_FILE" />
      </Button>
    </div>
  );
};

export const EventFileUploadStatusIcon: FC<{
  docLink?: string;
  isDuplicate: boolean;
  loadingIcon: ReactNode;
}> = ({ docLink, isDuplicate, loadingIcon }) => {
  if (!docLink) return <>{loadingIcon}</>;
  if (isDuplicate) return <InfoCircle className="size-4" />;
  return <UploadedFileIcon />;
};
